<script setup lang="ts">
import FormCategoriaExperiencia from '../components/form-categoria-experiencia.vue'
import { useCategoriaExperienciaStore } from '../store/useCategoriaExperienciaStore'

definePage({
  meta: {
    navActiveLink: 'admin-categoria-experiencia',
    action: 'create',
    subject: 'categoriaexperiencia',
  },
})

const { resetForm } = useCategoriaExperienciaStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormCategoriaExperiencia />
</template>
